import { ArrowUpRight, Play } from "lucide-react";

export function Hero() {
  return (
    <section
      id="hero-section"
      data-theme="dark"
      className="relative w-full overflow-hidden bg-background md:bg-transparent"
      style={{ minHeight: "100vh" }}
    >
      {/* Full-bleed background image for desktop */}
      <div
        className="absolute rounded-[20px] overflow-hidden left-1/2 -translate-x-1/2 w-[calc(100%-20px)] max-w-[1660px] hidden md:block"
        style={{ top: 10, bottom: 0 }}
      >
        <img
          src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6a2b20ec983b31ac4a594118.png"
          alt="The Outpost Creative hero background"
          className="w-full h-full object-cover object-center"
          width={1200}
          height={800}
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-black/25" />
      </div>

      {/* Desktop Content container */}
      <div
        className="relative z-10 hidden md:flex flex-col justify-between max-w-[1440px] mx-auto w-full"
        style={{ minHeight: "100vh", padding: "0 30px 40px" }}
      >
        {/* Top copy block */}
        <div
          className="flex flex-col gap-6"
          style={{ marginTop: "220px", maxWidth: 760 }}
        >
          {/* Sub-headline */}
          <p
            className="text-[#FFF9F4]"
            style={{
              fontFamily: "'Share Tech Mono', monospace",
              fontSize: "clamp(20px, 2.5vw, 35px)",
              lineHeight: "100%",
              letterSpacing: "-0.07em",
              maxWidth: 650,
            }}
          >
            We build the website, the Google presence, and the ads that fill
            your calendar with real jobs. You run the business. We handle the
            marketing.
          </p>

          {/* CTA button */}
          <div>
            <a
              href="/contact"
              className="inline-flex items-center gap-3 hover:opacity-90 transition-opacity"
              style={{
                background: "#FFF9F4",
                borderRadius: 20,
                padding: "10px 20px 10px 20px",
                fontFamily: "'Share Tech Mono', monospace",
                fontWeight: 700,
                fontSize: 21,
                lineHeight: "28px",
                letterSpacing: "-0.05em",
                color: "#000000",
              }}
            >
              Get In Touch
              <span
                className="flex items-center justify-center"
                style={{
                  background: "#ff4a11",
                  borderRadius: 6,
                  width: 32,
                  height: 32,
                }}
              >
                <ArrowUpRight size={20} color="#FFF9F4" strokeWidth={2.5} />
              </span>
            </a>
          </div>
        </div>

        {/* Bottom block: large brand name + stats */}
        <div className="mt-auto">
          {/* Stat: +100 WEBSITES BUILT — top-left */}
          <p
            className="text-[#FFF9F4] mb-2"
            style={{
              fontFamily: "'Share Tech Mono', monospace",
              fontSize: "clamp(16px, 1.8vw, 25px)",
              lineHeight: "33px",
            }}
          >
            +100 Websites Built
          </p>

          {/* Giant brand name */}
          <h1
            className="text-[#FFF9F4] leading-none"
            style={{
              fontFamily: "'Geist', sans-serif",
              fontWeight: 700,
              fontSize: "clamp(60px, 13vw, 211px)",
              letterSpacing: "-0.01em",
              lineHeight: 1,
            }}
          >
            The Outpost
          </h1>

          {/* Bottom row: AVG stat + results callout */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-2 mt-2">
            <p
              className="text-[#FFF9F4]"
              style={{
                fontFamily: "'Share Tech Mono', monospace",
                fontSize: "clamp(14px, 1.6vw, 25px)",
                lineHeight: "33px",
              }}
            >
              AVG +300% Increase In Traffic For Clients
            </p>
            <p
              className="text-[#FFF9F4]"
              style={{
                fontFamily: "'Share Tech Mono', monospace",
                fontSize: "clamp(14px, 1.6vw, 25px)",
                lineHeight: "33px",
              }}
            >
              (Results Shown Below)
            </p>
          </div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="md:hidden flex flex-col px-6 pt-[120px] pb-6 min-h-[100dvh] relative z-10">
        <div className="text-foreground font-heading font-bold text-[65px] leading-[0.9] tracking-tighter uppercase mb-6">
          THE OUTPOST<span className="text-[#b85736]">.</span>
        </div>
        <p className="text-foreground font-sans text-[22px] leading-snug mb-8 max-w-[90%]">
          We build the website, the Google presence, and the ads that fill your
          calendar with real jobs. You run the business. We handle the
          marketing.
        </p>
        <a
          href="/contact"
          className="text-[#b85736] font-sans font-bold text-xl tracking-wider uppercase flex items-center gap-1 border-b-2 border-[#b85736] w-fit pb-0.5 mb-[25px]"
        >
          Get in touch{" "}
          <ArrowUpRight size={22} strokeWidth={2.5} className="mb-1" />
        </a>

        <hr className="border-border border-t-2 mb-[25px]" />

        <div className="flex flex-col gap-2 mb-8">
          <div className="flex justify-between items-start w-full gap-4">
            <p className="text-[#b85736] font-sans font-bold uppercase tracking-widest text-[12px] leading-tight w-1/2">
              +100 WEBSITES BUILT
            </p>
            <div className="flex flex-col items-end w-1/2 gap-1">
              <p className="text-[#b85736] font-sans font-bold uppercase tracking-widest text-[12px] text-right leading-tight">
                AVG +300% INCREASE
              </p>
              <p className="text-[#b85736] font-sans font-bold uppercase tracking-widest text-[10px] text-right opacity-80">
                (RESULTS SHOWN BELOW)
              </p>
            </div>
          </div>
        </div>

        <div className="relative w-full rounded-[20px] overflow-hidden flex-grow min-h-[350px] mb-4">
          <img
            src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6a2b20ec983b31ac4a594118.png"
            alt="The Outpost Creative hero background"
            className="absolute inset-0 w-full h-full object-cover object-center"
            width={800}
            height={600}
            fetchPriority="high"
            decoding="async"
          />

          {/* Mobile Overlay Box */}
          <div className="absolute bottom-4 left-4 right-4 bg-[#e5e1d8] rounded-[12px] p-5 flex flex-col gap-4 shadow-xl z-10">
            <p className="text-[#2d2d2d] font-sans text-[16px] leading-snug">
              We provide comprehensive marketing solutions that help our clients
              reach their maximum potential.
            </p>
            <a
              href="/portfolio"
              className="flex items-center gap-2 text-[#ff4a11] font-sans font-medium text-[15px] uppercase tracking-wide"
            >
              <div className="bg-[#ff4a11] rounded-full p-1.5 flex items-center justify-center">
                <Play size={14} fill="white" color="white" className="ml-0.5" />
              </div>
              View Our work
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
